export default {
  S3_IMPORT_STAFF_PATH: "import/staffs",
  S3_IMPORT_STUDENT_PATH: "import/students",
  S3_IMPORT_SCORE_PATH: "import/scores",
  S3_IMPORT_ENROLL_STUDENT_PATH: "import/student-enroll",
  S3_IMPORT_ACT_PATH: "import/act",
  S3_IMPORT_SAT_PATH: "import/sat",
  S3_IMPORT_SBAC_PATH: "import/sbac",
  S3_IMPORT_PHYSICAL_PERFORMANCE_PATH: "import/physical-performance",
  S3_USER_UPLOAD_PATH: "users",
  S3_STAFFS_UPLOAD_PATH: "users/staffs",
  S3_COMMUNICATION_UPLOAD_PATH: "service/communication",
  S3_STUDENTS_UPLOAD_PATH: "users/students",
  S3_TASK_MANAGEMENT_UPLOAD_PATH: "school/task-management"
};
